export default __webpack_public_path__ + "static/media/pricePreview.f3993295.svg";